function BorderEdgeCut() {
    return (
        <div>
            <div className="z-10 w-10 h-14 top-0 left-0 -translate-x-4 -translate-y-6 rotate-45 absolute border-r-4 border-neon-yellow bg-zinc-900"></div>
            <div className="z-10 w-10 h-14 bottom-0 right-0 translate-x-4 translate-y-6 rotate-45 absolute border-l-4 border-neon-yellow bg-zinc-900"></div> 
        </div>
    )
}

export default BorderEdgeCut
